import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, gbp, errMsg } from "@/lib/api";

export default function SubscriptionsTab() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/subscriptions").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const cancel = async (s) => {
    if (!window.confirm(`Cancel ${s.customer.name}'s monthly box? They won't be charged again.`)) return;
    try {
      await api.post(`/admin/subscriptions/${s.id}/cancel`);
      toast.success("Subscription cancelled");
      load();
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!rows.length) return <p className="mt-6 text-slate-500" data-testid="subscriptions-empty">No monthly boxes yet. Customers can tick "Subscribe &amp; save 10%" at checkout.</p>;
  return (
    <div className="mt-4 space-y-3" data-testid="subscriptions-tab">
      {rows.map((s) => (
        <div key={s.id} className="rounded-2xl bg-white border border-[#EDE4D3] p-5 flex flex-wrap gap-4 items-start" data-testid={`subscription-${s.id}`}>
          <div className="flex-1 min-w-[220px]">
            <p className="font-semibold">{s.customer.name} <span className="text-slate-500 font-normal">· {s.customer.email}</span></p>
            <p className="text-sm text-slate-600 mt-1">{s.items.map((i) => `${i.name} × ${i.qty}`).join(", ")}</p>
            <p className="text-xs text-slate-500 mt-1">First order {s.first_order_number} · started {new Date(s.created_at).toLocaleDateString("en-GB")}</p>
          </div>
          <div className="text-right">
            <p className="font-serif text-xl font-bold">{gbp(s.total)}<span className="text-sm font-normal text-slate-500">/month</span></p>
            <p className={`text-xs font-semibold uppercase ${s.status === "active" ? "text-emerald-700" : "text-slate-400"}`} data-testid={`subscription-status-${s.id}`}>{s.status}</p>
            {s.status === "active" && <button onClick={() => cancel(s)} className="mt-2 rounded-full border border-[#E2D7C3] px-4 py-1.5 text-sm hover:text-rose-700" data-testid={`subscription-cancel-${s.id}`}>Cancel</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
